import React from "react";
import {change, formValueSelector, reducer as formReducer, reduxForm} from "redux-form";
import {combineReducers, createStore,} from "redux";
import {connect, Provider} from "react-redux";
import {RAQFinish, RAQForm} from "../components/BaseForm";
import "../index.css"
import FormHandlers from "../FormHandlers";
import "./index.css"
import {SelectModel} from "../components/ModelListContainer";
import twoSvg from "../images/2.svg";
import oneSvg from "../images/1.svg";
import {YourDetailsMarketing} from "../components/YourDetails";
import {RAQValidator, transformVehicle, validatePostcode} from "../util/Validators";
import {RequestAQuoteDirectCall} from "../components/DTMDirectCalls";

const rootReducer = combineReducers({
    form: formReducer,
});


const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const SUBMISSION_URL = process.env.REACT_APP_RAQ_URL;
const VERSION = process.env.REACT_APP_VERSION_ID;

class TransitionWrapper extends React.Component {


    yourDetailsCompleted(props) {
        const {firstname, lastname, email, postcode, phone, dealerfound, testdrivetiming} = props;
        return [firstname, lastname, email, postcode, phone].every((i) => i !== undefined && i.trim().length > 0);
    }

    dealerCompleted(props) {
        const {firstname, lastname, email, postcode, phone, dealerfound, testdrivetiming} = props;
        return dealerfound && testdrivetiming.trim().length > 0 && postcode.length > 0;
    }

    selectModelCompleted(props) {
        const {formState} = props;
        return formState.selectModel === true;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.selectModelCompleted(nextProps) === true && this.dealerCompleted(nextProps) === false) {
            setTimeout(function () {}, 500);
        }
        if (this.selectModelCompleted(nextProps) === true && this.dealerCompleted(nextProps) === true) {
            setTimeout(function () {}, 500);
        }

    }

    render() {
        const props = this.props;
        const {formState} = props;
        const {firstname, lastname, email, postcode, phone, dealerfound, testdrivetiming} = props;
        const yourDetailsCompleted = [firstname, lastname, email, postcode, phone].every((i) => i !== undefined && i.trim().length > 0);
        const dealerCompleted = dealerfound && testdrivetiming.trim().length > 0 && postcode.length > 0;
        let className = `select-model-false your-details-false testdrive-false`;
        if (formState) {
            className = ` select-model-${formState.selectModel} your-details-${yourDetailsCompleted} testdrive-${dealerCompleted}`
        }
        return (<div className={`select-model-true your-details-true testdrive-true`}>{props.children}</div>)
    }
}


const FormTransitionWrapper = (props) => {

    function C(props) {
        const {formState} = props;
        const {firstname, lastname, email, postcode, phone} = props;
        const yourDetailsCompleted = [firstname, lastname, email, postcode, phone].every((i) => i !== undefined && i.trim().length > 0);
        let className = ``;
        if (formState) {
            className += ` select-model-${formState.selectModel} your-details-${yourDetailsCompleted}`
        }
        return (<div className={`select-model-true your-details-true testdrive-true`}>
            {props.children}
        </div>)
    }


    const FormTransitionComponent = connect((state) => {
        const selector = formValueSelector(props.formName);
        return {
            formState: selector(state, 'formState'),
            firstname: selector(state, 'firstname'),
            lastname: selector(state, 'lastname'),
            email: selector(state, 'email'),
            postcode: selector(state, 'postcode'),
            phone: selector(state, 'phone'),
            'marketingOptIn': selector(state, 'marketingOptIn'),
        }
    })(reduxForm({form: props.formName})(C));

    return <FormTransitionComponent {...props} />
};


function App(props) {

    const {brand, formName, config} = props;
    const handlers = FormHandlers(SUBMISSION_URL, brand, config, {
        onSubmitSuccess: async function (results, dispatch, props) {
            const {formValues} = results;
            if (formValues) {
                const {vehicle, marketingOptIn, postcode, year, email ,  digitalData} = formValues;
                RequestAQuoteDirectCall(brand,config, true).complete(vehicle, year || config[transformVehicle(vehicle)].year, postcode, marketingOptIn, email , digitalData, window);
            }
            dispatch(change(formName, 'completed', true));
            dispatch(change(formName, 'response', results));
            setTimeout(() => {
                if (window.parentIFrame) {
                    window.parentIFrame.moveToAnchor("#top");
                }
            }, 500);

        }

    });

    RequestAQuoteDirectCall(brand, config , true).start();

    return (
        <Provider store={store}>
            <a name="top" data-version={VERSION}/>

            <div className={`${brand.value} container-fluid pl-0 pr-0`}>
                <RAQFinish formName={formName} brand={brand} config={config} data={"response"}/>

                <FormTransitionWrapper formName={formName}>

                    <RAQForm formName={formName || "fca-raq"} loader={props.loader}
                             handlePrePopulateModel={() => {
                                 setTimeout(function () {}, 500);
                             }}
                             componentWillMountCallback={async (p) => {
                                 return {};
                             }}
                             optionalConfig={{
                                 asyncChangeFields : ['postcode'],
                                 asyncValidate :  validatePostcode,
                                 validate: (values) => {return RAQValidator(values, );},
                                 initialValues: {
                                     completed: false,
                                     brand: brand,
                                     models: props.models,
                                     'firstname': "",
                                     'lastname': "",
                                     'postcode': '',
                                     'email': '',
                                     'phone': '',
                                     'marketingOptIn': true,
                                     'vehicle': '',
                                     'eVar39': '',
                                     'GACLIENTID': '',
                                     brandConfig: config,
                                     formState: {
                                         'selectModel': true
                                     }
                                 }
                             }}

                             onSubmit={handlers.onSubmit}
                             onSubmitFail={handlers.onSubmitFail}
                             onSubmitSuccess={handlers.onSubmitSuccess}
                             isFormValid={(props) => {
                                 const {formValues} = props;
                                 if (formValues !== undefined) {
                                     const {firstname, lastname, email, postcode, phone, vehicle, models , dealerfound } = formValues;
                                     const m = models.map(i => i.toLowerCase().trim());
                                     const v = vehicle.toLowerCase().trim();
                                     return /^[0-9]{4}$/.test(postcode) && dealerfound && [vehicle].every((i) => i !== undefined && i.trim().length > 0) && m.includes(v)
                                 } else {
                                     return false;
                                 }
                             }}

                    >

                        <SelectModel formName={formName} icon={oneSvg} handleClick={() => {
                            setTimeout(function () {}, 500);
                        }}/>
                        <hr className={'separator step-1'}/>
                        <YourDetailsMarketing formName={formName} icon={twoSvg} brand={brand} config={config}/>


                    </RAQForm>

                </FormTransitionWrapper>


            </div>
        </Provider>
    )
}


function RAQFinishRedux(props) {

    let Component = (reduxForm({
        form: props.formName,
        initialValues: {
            completed: true,
            brand: props.brand,
            models: [],
            'firstname': "stephen",
            'lastname': "smithstone",
            'postcode': '2000',
            'email': 'stephen.smithstone@digitas.com',
            'phone': '0491570156',
            'marketingOptIn': false,
            'vehicle': 'Grand Cherokee',
            brandConfig: props.config,
            response: {
                "request": {
                    "LeadSource": "Brand",
                    "LeadType": "New",
                    "Department": "sales",
                    "FormName": "Request A Quote",
                    "Brand": "Jeep",
                    "FirstName": "stephen",
                    "LastName": "smithstone",
                    "EmailAddress": "stephen.smithstone@digitas.com",
                    "MobileNumber": "0491570156",
                    "PostCode": "2000",
                    "PrivacyPolicy": true
                }, "response": {"statusCode": 200}
            }

        }
    })(RAQFinish));

    return <Component {...props}/>
}

export default App;
